import get from 'lodash/get';
import PropTypes from 'prop-types';

import Avatar from '@mui/material/Avatar';
import ClockIcon from '@mui/icons-material/AccessTime';
import Divider from '@mui/material/Divider';
import PinIcon from '@mui/icons-material/Place';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import {formatProviderName} from '../../helpers/providers';
import {formatPatientInitials,formatPatientName} from '../../helpers/patients';
import {parseSessionTypeLocationType} from '../../helpers/sessionTypes';

const SchedulingHeader = props => {
  const {provider, patient, sessionType, isProvider} = props;
  if (!provider && !isProvider) return <></>;
  return (
    <Stack spacing={1}>
      {
        isProvider
        ? <Stack direction='row' spacing={1} alignItems='center'>
          <Avatar>
            {formatPatientInitials(get(props, 'patient'))}
          </Avatar>
          <Typography variant='body1' color='text.light'>
            {formatPatientName(get(props, 'patient'))}
          </Typography>
        </Stack>
        : <Stack direction='row' spacing={1} alignItems='center'>
          <Avatar
            alt='provider profile picture'
            src={provider.imgSrc || get(provider, 'public_profile_img_url')}
          />
          <Typography variant='body1' color='text.primary'>
            {formatProviderName(provider)}
          </Typography>
        </Stack>
      }
      {
        sessionType
        ? <>
          <Typography variant='h2' style={{paddingTop: '0.5em'}} color='text.primary'>
            {sessionType ? sessionType.title : ''}
          </Typography>
          <Stack
            direction='row'
            spacing={2}
            style={{color: 'rgba(0,0,0,0.6)'}}
          >
            <Stack direction='row' spacing={1}>
              <ClockIcon/>
              <Typography variant='body1' color='text.light'>
                {sessionType.duration_minutes} Mins
              </Typography>
            </Stack>
            <Stack direction='row' spacing={1}>
              <PinIcon/>
              <Typography variant='body1' color='text.light'>
                {parseSessionTypeLocationType(sessionType)}
              </Typography>
            </Stack>
          </Stack>
          <Divider/>
          {/* <Typography 
            variant='body1' 
            color='text.primary'
            style={{whiteSpace: 'pre-line'}}
          >
            {sessionType.description}
          </Typography> */}
        </>
        : null
      }
    </Stack>
  );
};

SchedulingHeader.propTypes = {
  title: PropTypes.string,
  provider: PropTypes.object,
  sessionType: PropTypes.object,
  isProvider: PropTypes.bool,
};

export default SchedulingHeader;
